import { BuildModeType } from '@/constants/constants';

const GETID_FLOW_MAP: Record<string, string> = {
  canada: 'ontario',
  'normal:ca': 'canada',
  'normal:ca-fr': 'canada',
  'normal:at': 'austria',
};

export function getGetIdFlow(buildMode: BuildModeType, locale: string): string {
  return GETID_FLOW_MAP[`${buildMode}:${locale}`] ?? GETID_FLOW_MAP[buildMode] ?? 'row';
}
